import { GenericError, } from '@zurich-framework/core/errors';
export class NextAppBaseError extends GenericError {
    getTranslatedType(t) {
        return t(`nextapp:errors.${this.className}.type`);
    }
    getTranslatedMessage(t) {
        return t(`nextapp:errors.${this.className}.message`);
    }
}
